<template lang="pug">
div
  section.u-mh-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('mantra')")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('mantraItems')")
            h4(v-if="item.title") {{item.title}}
            p {{item.desc}}

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat 2015 in review",
    "pageDesc":"Baianat important events of the year 2015, the projects have accomplished and the stories that shaped who we are.",
    "mantra":"Towards the |digital era.",
    "mantraItems":{
      "1":{
        "desc":"Our biggest goal in 2015 was to confirm that we influence on community and culture, especially IT and digital culture. That is why our slogan 'We Believe We Can Change' was the best to reflect Baianat's mission."
      },
      "2":{
        "desc":"To achieve that goal, Baianat provided many open-source resources to everyone in the community, especially developers and designers to help them fulfil their tasks and learn new techniques. We presented case studies,blog articles and posts on social media, with the aim to enhance IT industry and enrich Arabic content on the World Wide Web."
      },
      "3":{
        "title":"Design resources",
        "desc":"We created +10 projects to inspire designers around the world to design. From icons to mockups and open videos, we were on a mission of empowering the Arab world with materials that educate them on the latest trends."
      },
      "4":{
        "title":"New identity",
        "desc":"As we were coming out of an era and heading towards a totally different one we needed a shock that tells the community of how we changed. We wanted to scream for the new era and outline our evolution to claim a new position in our clients mind. That’s why we created the brand to be multicolor and vivid. Using the basic colors red, blue, green and yellow gave us the boldness and modern look needed. In addition, we were listed as trend makers when it comes to using hero illustrations in UI design."
      },
      "5":{
        "title":"Portfolio expansion",
        "desc":"In 2015, we had business in more than 10 countries around the globe and supported a wider range of industries which encouraged us to do go the extra mile and plan for our international growth."
      }
    }
  },
  "ar": {
    "pageTitle":"إنجازات 2015",
    "pageDesc":"بيان بأهم الأحداث والإنجازات التي قامت بها بيانات في عام 2015 والمشاريع والقصص التي شكلت ما نحن عليه اليوم.",
    "mantra":"نحو العصر |الرقمي.",
    "mantraItems":{
      "1":{
        "desc":"كان هدفنا الأكبر في عام 2015 هو التأكيد على أننا نؤثر على المجتمع وثقافته إيجابيًا، خاصة تكنولوجيا المعلومات والثقافة الرقمية. هذا هو السبب في أن شعارنا ' نعتقد أن بإمكاننا التغيير' هو الشعار الأفضل الذي يعبر ويعكس مهمة بيانات."
      },
      "2":{
        "desc":"لتحقيق هذا الهدف، قدمت بيانات العديد من المصادر المفتوحة للجميع، وخاصة للمطورين والمصممين من أجل مساعدتهم على أداء مهامهم وتعلم التقنيات الجديدة.  كذلك قدمنا العديد من دراسات الحالة ومقالات في المدونة والمنشورات على وسائل التواصل الاجتماعي كل ذلك بهدف تعزيز صناعة تكنولوجيا المعلومات وإثراء المحتوى العربي على الإنترنت."
      },
      "3":{
        "title":"تصميمات مجانية",
        "desc":"أنشأت بيانات أكثر من 10 مشاريع لإلهام المصممين في جميع أنحاء العالم. من الأيقونات والقوالب إلى مقاطع الفيديو مفتوحة المصدر، لمساعدة المجتمع على الحصول علي هذه المصادر بدون أي عناء."
      },
      "4":{
        "title":"هوية جديدة",
        "desc":"كنا نتجه نحو حقبة مختلفة تمامًا تجاه عصر جديد، لهذا احتجنا إلى مفاجأة تخبر المجتمع كيف تغيرنا. أردنا التجديد والتطور وفي نفس الوقت حجز مكان مميز في أذهان عملائنا، ومن أجل ذلك أنشأنا علامة تجارية متعددة الألوان ومشرقة. باستخدام الألوان الأساسية الأحمر والأزرق والأخضر والأصفر أعطانا الجرأة والمظهر العصري المطلوب. بالإضافة إلى ذلك، تم إدراجنا ضمن صانعي الترندات بما يتعلق باستخدام الإليستريشن في تصميم واجهة المستخدم."
      },
      "5":{
        "title":"نمو بيانات",
        "desc":"في عام 2015 ، كان لدينا أعمال في أكثر من 10 دول حول العالم ودعمنا مجموعة واسعة من الصناعات التي شجعتنا على القيام بأقصى جهد من أجل نمونا الدولي."
      }
    }
  }
}
</i18n>
